export const ListIcon = (props) => {
  return (
    <svg
    width={props?.width ?? '23'}
    height={props.height ?? '20'}
      viewBox="0 0 23 20"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1082_38731)">
        <path
          d="M0 0C1.77674 0 3.55348 0 5.34337 0C5.34337 1.83399 5.34337 3.63451 5.34337 5.4618C5.23809 5.4618 5.15254 5.4618 5.06699 5.4618C3.46793 5.4618 1.86887 5.4618 0.269801 5.4618C0.184254 5.4618 0.0921271 5.46849 0.00658051 5.47519C0 3.64789 0 1.82729 0 0Z"
          fill={props?.color ?? '#5B5B5B'}
          // fill={props?.view == 'list' ? '#3D5A80' : '#5B5B5B'}
        />
        <path
          d="M0 13.621C0.355348 13.6277 0.710695 13.6344 1.06604 13.6344C2.40189 13.6344 3.73115 13.6344 5.06699 13.6344C5.15254 13.6344 5.24467 13.6344 5.34337 13.6344C5.34337 15.4617 5.34337 17.2689 5.34337 19.0962C3.55348 19.0962 1.77674 19.0962 0 19.0962C0 17.2689 0 15.4416 0 13.621Z"
          fill={props?.color ?? '#5B5B5B'}
        />
        <path
          d="M0 6.83394C1.757 6.83394 3.50741 6.82725 5.26441 6.82725C5.28415 6.82725 5.30389 6.83394 5.34337 6.84733C5.34337 8.64115 5.34337 10.4417 5.34337 12.2489C5.31705 12.2556 5.29073 12.2757 5.26441 12.2757C3.50741 12.2757 1.757 12.2757 0 12.269C0 10.4551 0 8.64115 0 6.83394Z"
          fill={props?.color ?? '#5B5B5B'}
        />
        <path
          d="M6.7121 5.44841C6.7121 3.63451 6.7121 1.83399 6.7121 0.0200806C12.0621 0.0200806 17.3988 0.0200806 22.7554 0.0200806C22.7554 1.8206 22.7554 3.62781 22.7554 5.44841C17.4252 5.44841 12.0818 5.44841 6.7121 5.44841Z"
          fill={props?.color ?? '#5B5B5B'}
        />
        <path
          d="M22.762 13.6478C22.762 15.455 22.762 17.2488 22.762 19.0694C17.4186 19.0694 12.0752 19.0694 6.7121 19.0694C6.7121 17.2622 6.7121 15.4684 6.7121 13.6478C12.0621 13.6478 17.412 13.6478 22.762 13.6478Z"
          fill={props?.color ?? '#5B5B5B'}
        />
        <path
          d="M22.7685 6.84064C22.7685 8.65454 22.7685 10.4484 22.7685 12.2556C17.4186 12.2556 12.0686 12.2556 6.7121 12.2556C6.7121 10.4484 6.7121 8.64785 6.7121 6.84064C12.0686 6.84064 17.4054 6.84064 22.7685 6.84064Z"
          fill={props?.color ?? '#5B5B5B'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1082_38731">
          <rect width="22.7686" height="19.0962" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
